import { CodeComponentPropertyDefinition } from "./SDKCodeComponentPropertyDefinition";
export class CodeComponent {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.packageName = model.packageName;
        this.repositoryName = model.repositoryName;
        this.description = model.description;
        this.filePath = model.filePath;
        this.props = model.props.map((prop) => new CodeComponentPropertyDefinition(prop));
        this.storybookFiles = model.storybookFiles;
        this.docFiles = model.docFiles;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
    }
}
